module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sheldon Russell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("DR. SHELDON RUSSELL is the author of five novels. He lives in Guthrie, Oklahoma.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17hup3a/tc-custom/9781250010582.jpg?1724600880351",
      "alt": "This image is the cover for the book Dead Man's Tunnel, The Hook Runyon Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dead Man's Tunnel, The Hook Runyon Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("Dead Man's Tunnel")]), _vm._v(" is the third installment in Sheldon Russell's 1940s series featuring yard dog Hook Runyon."), _c('br'), _c('br'), _vm._v("Near the end of WWII, Hook Runyon, railroad bull, and his dog, Mixer, are sent to the West Salvage Yard in the high desert of Arizona. Not far away is the Johnson Canyon Tunnel. Though remote and ordinary as tunnels go, it is the gateway to the steepest railroad grade in North America and a potential bottleneck for the delivery of war supplies. So vital is this tunnel to the war effort that a twenty-four hour military guard has been assigned for the duration. Hook's orders are to catch copper thieves and to stay out of sight and out of trouble. But things go awry when Hook receives a call that one of the guards has been killed mid-tunnel by an oncoming train. Lieutenant Allison Capron from the Army Transportation Department is called in to help with the investigation. At first, suicide by train is suspected, but the evidence soon suggests homicide resulting from a love triangle. Unable to fit his own findings into either of these theories, Hook suspects something more sinister.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Minotaur Books\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0